export default __webpack_public_path__ + "static/media/meter_preview.9c15efbc.jpg";